// app/javascript/controllers/driving_school_program_selection_list_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["hiddenProgram", "toggleShowButton"]

  connect() {
    this.updateButtonText()
  }

  toggleShow() {
    this.hiddenProgramTargets.forEach(program => {
      program.classList.toggle("u-hidden")
    })

    this.updateButtonText()
  }

  updateButtonText() {
    if (!this.hasToggleShowButtonTarget) return

    const hasAnyHidden = this.hiddenProgramTargets.some(program =>
      program.classList.contains("u-hidden")
    )

    this.toggleShowButtonTarget.textContent = hasAnyHidden
      ? "Show more"
      : "Show fewer"
  }
}